 <div class="ldngOvrlyCss">
    <div class="loading-indicator">
      <div class="spinner-2">
         <img src="../../../../assets/images/logo/dreamstep_D.png" alt="Loading..."  style="    width: 40px;
        max-width: 40px;
        margin-top: -3px;"> 
      </div>
    </div>
</div> 